import { render, staticRenderFns } from "./LoyaltyProgram.vue?vue&type=template&id=bef55430&scoped=true"
import script from "./LoyaltyProgram.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgram.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyProgram.vue?vue&type=style&index=0&id=bef55430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef55430",
  null
  
)

export default component.exports